<template>
    <label :class="size" class="ui-input ui-color-picker" @mouseleave="hideColorPicker">
        <span class="label ui-color-picker-label" v-if="label">
            <span v-html="label"></span>
        </span>
        <div class="ui-color-picker-container">
            <input
                :value="value"
                type="text"
                autocomplete="off"
                class="input ui-color-picker-input"
                @focus="showColorPicker"
                @input="changeColor" />
            <ui-badge :color="value" class="ui-color-picker-badge" @click="showColorPicker" />
            
            <chrome-picker
                v-show="show"
                :value="value"
                class="ui-color-picker-application"
                ref="colorpicker"
                @input="updateColor" />
        </div>
    </label>
</template>

<script>
    import { Chrome } from 'vue-color'
    import uiBadge from '@/components/ui/badge'

    export default {
        components: {
            uiBadge,
            'chrome-picker': Chrome,
        },

        props: {
            label: {
                type: String,
                required: false,
            },

            value: {
                required: true,
            },
            
            /**
             * Utilize para alterar o tamanho do input
             */
            size: {
                type: String,
                required: false,
                default: 'md'
            },
        },

        data() {
            return {
                show: false,
            }
        },

        methods: {
            showColorPicker() {
                this.show = true
            },

            hideColorPicker() {
                this.show = false
            },

            updateColor(val) {
                this.$emit('input', val.hex)
            },

            changeColor(event) {
                this.$emit('input', event.target.value)
            },
        },
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>
